/*
 * @Author: cc
 * @LastEditTime: 2022-08-18 14:35:22
 */
import { InitvideoState, VideoProps } from "@root/actions/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: VideoProps = InitvideoState;

export const videoSlice = createSlice({
  name: "videoInfo",
  initialState,
  reducers: {
    setVideoInfo: (state, action: PayloadAction<VideoProps>) => {
      state = action.payload;
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
const { actions, reducer } = videoSlice;
export const { setVideoInfo } = actions;
export default reducer;
